import { AuditAlertDetail } from "modules/auditLog";

const AuditAlertDetailPage = () => {
  return <AuditAlertDetail />;
};

export default AuditAlertDetailPage;
